export default __webpack_public_path__ + "static/media/mode-510.a579b7b9.svg";